export type McpOAuthResult = 'success' | 'error';

export interface McpOAuthReturnParams {
    setupId: string;
    result: McpOAuthResult;
    reasonCode: string | null;
}

const getSingleSearchParam = (searchParams: URLSearchParams, key: string): string | null => {
    const values = searchParams.getAll(key);
    if (values.length !== 1) {
        return null;
    }

    const value = values[0]?.trim();
    return value || null;
};

export const parseMcpOAuthReturnParams = (search: string): McpOAuthReturnParams | null => {
    const searchParams = new URLSearchParams(search);
    const setupId = getSingleSearchParam(searchParams, 'setup_id');
    const result = getSingleSearchParam(searchParams, 'result');
    const reasonCode = getSingleSearchParam(searchParams, 'reason_code');

    if (!setupId || (result !== 'success' && result !== 'error')) {
        return null;
    }

    return {
        setupId,
        result,
        reasonCode,
    };
};
